import api, { handleApiResponse } from './api';
import {
  BuildingType,
  ApiResponse,
  WorkCategoryWithPercentage,
  BuildingTypeWithoutWorkTypes,
} from '../types';

interface BuildingTypesResponse {
  success: boolean;
  message: string;
  data: BuildingType[];
  timestamp: string;
}

export const buildingTypeService = {
  // Obtener building types con asociaciones
  async getAllBuildingTypesWithWorkTypes(): Promise<BuildingTypesResponse> {
    const response = await api.get<BuildingTypesResponse>(
      '/settings/building-types',
    );
    console.log('Response from getAllBuildingTypesWithWorkTypes:', response);
    return response.data;
  },

  async getAllBuildingTypes(): Promise<BuildingTypeWithoutWorkTypes[]> {
    const response = await api.get<ApiResponse<BuildingTypeWithoutWorkTypes[]>>(
      '/settings/building-types/alone',
    );
    return handleApiResponse(response);
  },

  // Crear nuevo building type con work categories
  async createBuildingTypeWithWorkTypes(buildingTypeData: {
    value: string;
    description: string;
    workCategories: {
      workCategoryId: number;
      percentage: number;
    }[];
  }): Promise<BuildingType> {
    const response = await api.post<ApiResponse<BuildingType>>(
      '/settings/building-types',
      buildingTypeData,
    );
    return handleApiResponse(response);
  },

  // Eliminar building type
  async deleteBuildingType(buildingTypeId: number): Promise<void> {
    await api.delete(`/settings/building-types/${buildingTypeId}`);
  },

  // Actualizar building type
  async updateBuildingType(
    buildingTypeId: number,
    buildingTypeData: {
      value: string;
      description: string;
      workCategories: {
        workCategoryId: number;
        percentage: number;
      }[];
    },
  ): Promise<BuildingType> {
    const response = await api.put<ApiResponse<BuildingType>>(
      `/settings/building-types/${buildingTypeId}`,
      buildingTypeData,
    );
    return handleApiResponse(response);
  },

  async getWorkCategoriesByBuildingTypeId(
    buildingTypeId: number,
  ): Promise<WorkCategoryWithPercentage[]> {
    const response = await api.get<ApiResponse<WorkCategoryWithPercentage[]>>(
      `/settings/building-types/${buildingTypeId}/work-categories`,
    );
    return handleApiResponse(response);
  },
};

export default buildingTypeService;
